import { defineProvider } from '@nuxt/image/runtime'

export const supportsAlias = true

export default defineProvider({
    getImage(src) {
        return { url: imageCDN(src) }
    }
})
